import { Tooltip } from "@bigbinary/neeto-atoms";
import { Columns3 } from "lucide-react";
import { useTranslation } from "react-i18next";

import ManageColumns from "../../Columns";

const Columns = ({
  buttonProps = {},
  columnData,
  onMutationSuccess,
  allowConfigurationResetOnUpdate,
  tableKey,
  ...props
}) => {
  const { t } = useTranslation();

  const tooltipContent = t("neetoMolecules.columns.columns");

  return (
    <div>
      <Tooltip content={tooltipContent} position="bottom">
        <div className="inline-flex">
          <ManageColumns
            isSearchable
            buttonProps={{
              icon: Columns3,
              "data-testid": "columns-dropdown-button",
              ...buttonProps,
            }}
            {...{
              allowConfigurationResetOnUpdate,
              columnData,
              onMutationSuccess,
              tableKey,
              ...props,
            }}
          />
        </div>
      </Tooltip>
    </div>
  );
};

Columns.displayName = "Columns";
export default Columns;
